import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "./services/authentication.service";
import { StoreService } from 'src/stores/setting.store'
import {SettingsService} from 'src/app/services/settings.service'

@Component({
  selector: "app-root",
  template: `
    <router-outlet></router-outlet>
    <ng-progress></ng-progress>
    <notifier-container></notifier-container>
  `
})
export class AppComponent {
  currentUser: boolean;
  title = "ATSAdmin";

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private store: StoreService,
    private settingServices: SettingsService
  ) {
    this.currentUser = localStorage.getItem("token") != null ? true : false;
  }
  ngOnInit(): void {
    this.settingServices.getAll().subscribe(data => {
      this.store.setSettings(data['result'] || []);
    })
  }
  profile() {}
}
